/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Strategy_Partner_Status_Coming_SoonInputs */

const en_strategy_partner_status_coming_soon = /** @type {(inputs: Strategy_Partner_Status_Coming_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coming soon`)
};

const de_strategy_partner_status_coming_soon = /** @type {(inputs: Strategy_Partner_Status_Coming_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demnächst verfügbar`)
};

const pt_br2_strategy_partner_status_coming_soon = /** @type {(inputs: Strategy_Partner_Status_Coming_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em breve`)
};

const tr_strategy_partner_status_coming_soon = /** @type {(inputs: Strategy_Partner_Status_Coming_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yakında`)
};

const zh_cn2_strategy_partner_status_coming_soon = /** @type {(inputs: Strategy_Partner_Status_Coming_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`即将推出`)
};

const zh_hk2_strategy_partner_status_coming_soon = /** @type {(inputs: Strategy_Partner_Status_Coming_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`即將推出`)
};

const ko_kr2_strategy_partner_status_coming_soon = /** @type {(inputs: Strategy_Partner_Status_Coming_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`출시 예정`)
};

const ru_ru2_strategy_partner_status_coming_soon = /** @type {(inputs: Strategy_Partner_Status_Coming_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скоро`)
};

const es_419_strategy_partner_status_coming_soon = /** @type {(inputs: Strategy_Partner_Status_Coming_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximamente`)
};

/**
* | output |
* | --- |
* | "Coming soon" |
*
* @param {Strategy_Partner_Status_Coming_SoonInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const strategy_partner_status_coming_soon = /** @type {((inputs?: Strategy_Partner_Status_Coming_SoonInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Strategy_Partner_Status_Coming_SoonInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_strategy_partner_status_coming_soon(inputs)
	if (locale === "de") return de_strategy_partner_status_coming_soon(inputs)
	if (locale === "pt-BR") return pt_br2_strategy_partner_status_coming_soon(inputs)
	if (locale === "tr") return tr_strategy_partner_status_coming_soon(inputs)
	if (locale === "zh-CN") return zh_cn2_strategy_partner_status_coming_soon(inputs)
	if (locale === "zh-HK") return zh_hk2_strategy_partner_status_coming_soon(inputs)
	if (locale === "ko-KR") return ko_kr2_strategy_partner_status_coming_soon(inputs)
	if (locale === "ru-RU") return ru_ru2_strategy_partner_status_coming_soon(inputs)
	return es_419_strategy_partner_status_coming_soon(inputs)
});